import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import { Card } from 'antd';
import ModelForm from './ModelForm';
import UomDetailActions from '../../Stores/UomDetail/Actions';

class UomDetailScreen extends React.PureComponent {
  componentDidMount() {
    const { match, setReslId } = this.props;

    if (match.params.action === 'create') {
      setReslId(0);
    } else if (match.params.action === 'update') {
      setReslId(parseInt(match.params.id, 10));
    }
  }

  componentDidUpdate() {}

  componentWillUnmount() {}

  render() {
    const { intl, match, model } = this.props;

    return (
      <Card title={`${intl.formatMessage({ id: 'uom' })} ${model.code}`}>
        <ModelForm match={match} />
      </Card>
    );
  }
}

UomDetailScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  setReslId: PropTypes.func,
  model: PropTypes.shape({
    code: PropTypes.string
  })
};

UomDetailScreen.defaultProps = {
  intl: {},
  match: {},

  setReslId() {},
  model: { code: '' }
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  model: state.itemDetail.model
});

const mapDispatchToProps = dispatch => ({
  setReslId: resId => dispatch(UomDetailActions.uomDetailSetResId(resId))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(UomDetailScreen));
